import type {
  ClientAccessImpact,
  ClientAccessSettings,
  ClientAccessSettingsUpdateRequest,
} from "@repo/shared/types";
import { get, patch } from "./_client";

/** Admin only — either or both settings. */
export const updateClientAccessSettings = (body: ClientAccessSettingsUpdateRequest) =>
  patch<ClientAccessSettings>(
    "/internal/tenant/client-access",
    body satisfies ClientAccessSettingsUpdateRequest,
  );

/** Admin only — how the clients would split into audiences under the `target` settings. */
export const getClientAccessImpact = (target: ClientAccessSettings) =>
  get<ClientAccessImpact>(
    `/internal/tenant/client-access/impact?privateEnabled=${target.privateEnabled}&teamAccessEnabled=${target.teamAccessEnabled}`,
  );
